<template>
  <div class="email-content">
    <div class="email-show email email_h5">
      <h5>来信展示</h5>
      <!-- <p>展示管理员选登公开的信件</p> -->
      <div class="btn" @click="toLxzs" style="display: none;">去看看</div>
    </div>

    <div class="email-xzxx email">
      <h5>校长信箱</h5>
      <!-- <p>写信反馈</p> -->
      <div style="display: flex;">
        <!-- <div class="btn" @click="toXzxx" style="margin-right: 10px;">去看看</div> -->
        <div
          class="btn"
          @click="toWriteEmail"
          @mouseover="mouseover($event)"
          @mouseleave="mouseleave($event)"
        >我要写信</div>
      </div>
    </div>

    <div class="email-jdcx email">
      <h5>进度查询</h5>
      <!-- <p>
        <span>查询进度</span>
        <span>评价反馈</span>
      </p>-->
      <div
        class="btn"
        @click="jdcx"
        @mouseover="mouseover($event)"
        @mouseleave="mouseleave($event)"
      >我的信件</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    toLxzs() {
      window.open(window.lxzsUrl);
    },
    toXzxx() {
      window.open(window.xzxxUrl);
    },
    jdcx() {
      window.open(window.jdcxUrl);
    },
    toWriteEmail() {
      window.open(window.myWriteEmailUrl);
    },
    mouseover($event) {
      console.log($event)
      $event.currentTarget.className = 'btn other_btn_hover'
    },
    mouseleave($event) {
      $event.currentTarget.className = 'btn other_btn_leave'
    }
  }
};
</script>
<style scoped>
.email-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.email-show {
  background: url(../../static/assets/laixinzhanshi.png) no-repeat;
  background-size: 100% 100%;
  width: 31.87rem;
  height: 6.75rem;
  padding: 1.5rem 1.88rem;
  margin-right: 1.25rem;
}

.email-xzxx {
  background: url(../../static/assets/xiaozhangxinxiang.png) no-repeat;
  background-size: 100% 100%;
  width: 13.37rem;
  height: 6.75rem;
  padding: 1.5rem 1.88rem;
  margin-right: 1.25rem;
}

.email-jdcx {
  background: url(../../static/assets/jinduchau.png) no-repeat;
  background-size: 100% 100%;
  width: 13.37rem;
  height: 6.75rem;
  padding: 1.5rem 1.88rem;
}

.email h5 {
  font-size: 1.44rem;
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 2rem;
  /* margin-bottom: 0.63rem; */
}

.email p {
  font-size: 0.88rem;
  color: #ffffff;
  margin-bottom: 1.88rem;
}

.email p > span {
  margin-right: 1.25rem;
}

.btn {
  width: 4rem;
  height: 1.75rem;
  line-height: 1.75rem;
  text-align: center;
  background: #ffffff;
  border-radius: 0.88rem;
  font-size: 0.75rem;
  color: #262626;
  font-weight: 400;
  cursor: pointer;
}

.other_btn_hover {
  /* transform: translateY(0.25rem); */
  transform: scale(1.2);
  transition: all 0.2s;
  background: #395eaa;
  color: #fff;
}

.other_btn_leave {
  transform: scale(1);
  transition: all 0.2s;
  background: #ffffff;
  color: #262626;
  cursor: pointer;
} 
.email_h5 h5{
  font-size: 2rem;
  margin-bottom: 0;
  margin-top: 1.5rem;
}
</style>


// WEBPACK FOOTER //
// email.vue?75d628be